import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useRuleVersionActionsContext } from '../RuleVersionActionsProvider/RuleVersionActionsProvider.context';
import { I18nNamespace } from '~/common/types';

import { AlertStyled } from './RulePublishAlert.styled';

export const RulePublishAlert = () => {
  const { t: tAction } = useTranslation(I18nNamespace.ruleBuilder, { keyPrefix: 'DetailPage.action' });
  const { t: tMessage } = useTranslation(I18nNamespace.ruleBuilder, { keyPrefix: 'DetailPage.message' });

  const { publish, hasUnpublishedChanges } = useRuleVersionActionsContext();

  return hasUnpublishedChanges ? (
    <AlertStyled
      severity="info"
      action={
        <Button variant="text" color="inherit" size="small" onClick={publish}>
          {tAction('publish')}
        </Button>
      }
    >
      {tMessage('unpublishedChanges')}
    </AlertStyled>
  ) : null;
};
